export const SET_LEFT_NAV_DATA = 'left-nav-customization/SET_LEFT_NAV_DATA';
export const SELECTED_NAV_ITEM = 'left-nav-customization/SELECTED_NAV_ITEM';
export const REMOVE_NAV_ITEM = 'left-nav-customization/REMOVE_NAV_ITEM';
export const REMOVE_NAV_SUB_ITEM = 'left-nav-customization/REMOVE_NAV_SUB_ITEM';
export const SET_LEFT_NAV_DATA_FIXED = 'left-nav-customization/SET_LEFT_NAV_DATA_FIXED';
export const ADD_SUB_ITEM = 'left-nav-customization/ADD_SUB_ITEM';
export const RETURN_INITIAL_NAV_DATA = 'left-nav-customization/RETURN_INITIAL_NAV_DATA';
export const UPDATE_INITIAL_NAV_DATA = 'left-nav-customization/UPDATE_INITIAL_NAV_DATA';
